import {
  CalendarFilled,
  CarFilled,
  CloseCircleFilled,
  CloudFilled,
  CustomerServiceOutlined,
  ExclamationCircleFilled,
  FlagOutlined,
  MenuOutlined,
  NotificationFilled,
  SearchOutlined,
  UndoOutlined,
  UserOutlined,
  WechatOutlined,
} from '@ant-design/icons';
import {
  Divider,
  Drawer,
  Input,
  Layout,
  Menu,
  MenuProps,
  Spin,
  message,
  Badge,
  Dropdown,
  Button,
  Tooltip,
  Empty,
  Modal,
  Row,
  Col,
} from 'antd';
import { ReactComponent as Language } from '../../../../assets/images/language.svg';
import { ReactComponent as Notification } from '../../../../assets/images/notification.svg';
import { ReactComponent as Profile } from '../../../../assets/images/profile.svg';
import { platformConfig, platformKey as pk } from '../../../../core/config/platform';
import useRouterWithLang from '../../../../core/hooks/useRouterWithLang';
import { AppRouteKey } from '../../../../core/utilities/router';
import './Header.scss';
import type { InputRef } from 'antd';
import { ReactComponent as Bills } from '../../../../assets/images/bill-icon.svg';
import { ReactComponent as Cars } from '../../../../assets/images/car-icon.svg';
import { ReactComponent as Dashboard } from '../../../../assets/images/dashboard-icon.svg';
import { ReactComponent as Demands } from '../../../../assets/images/demands-icon.svg';
import { ReactComponent as Financial } from '../../../../assets/images/financial-icon.svg';
import { ReactComponent as Help } from '../../../../assets/images/help-icon.svg';
import { ReactComponent as News } from '../../../../assets/images/news-icon.svg';
import { ReactComponent as Service } from '../../../../assets/images/service-icon.svg';
import { ReactComponent as Users } from '../../../../assets/images/users-icon.svg';
import useLang from '../../../../core/hooks/useLang';
import { useTranslate } from '../../../../i18n';
import { useAppDispatch } from '../../../../core/services/hooks';
import { logout } from '../../../../core/services/auth/logout/logout.slice';
import React, { useState, useEffect, useRef, useMemo } from 'react';
import { getProfile } from '../../../../core/services/profile/profile.service';
import { useAppSelector } from '../../../../core/services/hooks';
import { SubCompanyDto } from '../../../../core/models/dtos/subCompany.dto';
import { subCompanySelect } from '../../../../core/services/hedefnet/subCompanySelect/subCompanySelect.slice';
import { getSubCompanies } from '../../../../core/services/hedefnet/getSubCompanies/getSubCompanies.slice';
import { useTranslation } from 'react-i18next';
import FlagEn from '../../../../assets/images/en.png';
import FlagTr from '../../../../assets/images/tr.png';
import { useLocation, useNavigate } from 'react-router-dom';
import { getLiveUrl } from '../../../../core/services/hedefnet/getLiveUrl/getLiveUrl';
import useContent, { useVis } from '../../../../core/hooks/useContent';
import { listAllNotification } from '../../../../core/services/userNotification/userNotification.slice';
import { UserNotificationType } from '../../../../core/models/enums/notification';
import { UserNotification } from '../../../../core/models/response/notification';
import {
  AcceptBuyCarNotification,
  ReadListNotification,
} from '../../../../core/services/userNotification/userNotification.repository';
import Helpers from '../../../../core/utilities/helpers';

const notificationIconSelector = (type: UserNotificationType) => {
  switch (type) {
    case UserNotificationType.APPOINTMENT:
      return <CalendarFilled style={{ color: platformConfig.primaryColor, fontSize: '16px' }} />;
    case UserNotificationType.CAMPAIGN:
      return (
        <NotificationFilled style={{ color: platformConfig.primaryColor, fontSize: '16px' }} />
      );
    case UserNotificationType.OVERDUE_INVOICE:
      return (
        <ExclamationCircleFilled
          style={{ color: platformConfig.primaryColor, fontSize: '16px' }}
        />
      );
    case UserNotificationType.VEHICLE_RETURN:
      return <CarFilled style={{ color: platformConfig.primaryColor, fontSize: '16px' }} />;
    case UserNotificationType.CAR_BUY:
      return <CarFilled style={{ color: platformConfig.primaryColor, fontSize: '16px' }} />;
    case UserNotificationType.WEATHER:
      return <CloudFilled style={{ color: platformConfig.primaryColor, fontSize: '16px' }} />;
    default:
      return (
        <NotificationFilled style={{ color: platformConfig.primaryColor, fontSize: '16px' }} />
      );
  }
};

function Header() {
  const dispatch = useAppDispatch();
  const { lang } = useLang();
  const { t } = useTranslate(lang, 'home');
  const [appSearch, setAppSearch] = useState<string>('');
  const [suggestions, setSuggestions] = useState<any>([]);
  const [showSuggestions, setShowSuggestions] = useState<boolean>(false);
  const inputRef = useRef<InputRef>(null);
  const suggestionsRef = useRef<HTMLDivElement>(null);
  const [profile, setProfile] = useState<any>();
  const { current, push } = useRouterWithLang();
  const content = useContent();
  const { pathname } = useLocation();
  const [selectedId, setSelectedId] = useState<any>();
  const { i18n } = useTranslation();
  const visibility = useVis();
  const me = useAppSelector((state) => state.app.setMe.me);
  const [modal, contextHolder] = Modal.useModal();
  const showCreditCard =
    process.env.REACT_APP_ENV !== 'production' || me?.checkCreditCard;
  const notifications = useAppSelector((state) => {
    return state.notification.listAll.data;
  });

  const [buyCarId, setBuyCarId] = useState<number | undefined>(undefined);
  const [buyCarLoading, setBuyCarLoading] = useState<boolean>(false);

  const limitedNotifications = useMemo(() => {
    let limit = 4;
    if (notifications && notifications.length > 0) {
      const isOverdue = notifications[0].id === -1;
      if (isOverdue) {
        limit = 5;
      }
      return notifications?.filter((_, index) => {
        if (isOverdue) {
          return index !== 0 && index < limit;
        }
        return index < limit;
      });
    }
    return [] as UserNotification[];
  }, [notifications]);

  const overdueNotification = useMemo(() => {
    if (notifications && notifications.length > 0) {
      if (notifications[0].id === -1) {
        return notifications[0];
      }
      return null;
    }
    return null;
  }, [notifications]);
  const location = useLocation();

  const isOnDashboard = useMemo(() => {
    return (
      location.pathname.endsWith('/dashboard') ||
      location.pathname.includes('/dashboard/')
    );
  }, [location]);

  const changeLanguage = (lng: any) => {
    const path = pathname.split('/')[2];
    const search = pathname.split('/')[3];
    const newUrl = `/${lng}/${path}/${search !== undefined ? search : ''}`;
    window.location.href = newUrl;
  };
  const userId = JSON.parse(localStorage.getItem('session') || 'null');
  const navigate = useNavigate();
  const { provideUrl } = useRouterWithLang();
  useEffect(() => {
    getProfile()
      .then((data: any) => {
        setProfile(data);
      })
      .catch((error: any) => {
        console.log(error);
      });
  }, []);

  const getSubCompaniesState = useAppSelector(
    (state) => state.hedefnet.getSubCompanies
  );
  const items: MenuProps['items'] = [
    {
      key: 'live',
      icon: <WechatOutlined className="text-white text-2xl" />,
      onClick: () => {
        getLiveUrl().then((data) => {
          console.log(data.url);
          window.open(data.url, '_blank');
        });
      },
    },
    {
      key: 'language',
      icon: <Language />,
      children: [
        {
          key: i18n.language === 'tr' ? 'en' : 'tr',
          icon: (
            <img
              className="w-4 h-4 mr-1 rounded-full"
              src={i18n.language === 'tr' ? FlagEn : FlagTr}
              alt="..."
            />
          ),
          label: i18n.language === 'tr' ? 'EN' : 'TR',
          onClick: () => changeLanguage(i18n.language === 'tr' ? 'en' : 'tr'),
        },
      ],
    },
    // {
    //   key: 'notification',
    //   icon: (
    //     <Badge count={notification?.length} offset={[-10, 10]}>
    //       <Notification />
    //     </Badge>
    //   ),
    //   children: [
    //     {
    //       key: 'Test',
    //       label: 'Test',
    //     },
    //   ],
    // },
    {
      key: 'SubMenu',
      icon: <Profile />,
      children: [
        {
          key: AppRouteKey.PROFILE,
          label: content(pk('profile.button.profile')),
        },
        {
          key: AppRouteKey.LOGIN,
          label: content(pk('profile.button.log.out')),
          onClick: () => {
            dispatch(logout());
          },
        },
      ],
    },
  ];

  const onClick: MenuProps['onClick'] = (e) => {
    if (e.key !== 'language') {
      push(e.key);
    }
    if (open) {
      setOpen(false);
    }
  };

  const recommend = [
    {
      label: content(pk('menu.dashboard')),
      key: 'dashboard',
      icon: <Dashboard />,
    },
    {
      label: content(pk('menu.user')),
      key: AppRouteKey.USERS,
      icon: <Users />,
    },
    {
      label: content(pk('menu.demand.additional.product.service.request')),
      key: AppRouteKey.DEMANDS,
      icon: <Demands />,
    },
    {
      label: content(pk('menu.demand.process.request')),
      key: AppRouteKey.PROCESSUALDEMANDS,
      icon: <Demands />,
    },
    {
      label: content(
        pk('menu.fleet.vehicle.management.fleet.vehicle.info')
      ),
      key: AppRouteKey.FLEETINFORMATION,
      icon: <Cars />,
    },
    {
      label: content(pk('menu.fleet.vehicle.management.vehicle.hgs.info')),
      key: AppRouteKey.HGSINFO,
      icon: <Cars />,
    },
    {
      label: content(pk('menu.fleet.vehicle.management.vehicle.return')),
      key: AppRouteKey.CARRETURN,
      icon: <Cars />,
    },
    {
      label: content(pk('menu.fleet.vehicle.management.document')),
      key: AppRouteKey.DOCUMENTS,
      icon: <Cars />,
    },
    {
      label: content(pk('menu.invoice.operational.bill')),
      key: AppRouteKey.OPERATIONALBILL,
      icon: <Bills />,
    },
    {
      label: content(pk('menu.invoice.financial.bill')),
      key: AppRouteKey.FINANCIALBILL,
      icon: <Bills />,
    },
    {
      label: content(pk('menu.invoice.additional.service.billa')),
      key: AppRouteKey.ADDITIONALSERVICES,
      icon: <Bills />,
    },
    {
      label: content(pk('menu.invoice.other.reflection.bill')),
      key: AppRouteKey.OTHERREFLECTION,
      icon: <Bills />,
    },
    {
      label: content(
        pk('menu.financial.operation.balance.reconciliation.confirmation')
      ),
      key: AppRouteKey.BALANCECONFIRMATION,
      icon: <Financial />,
    },
    {
      label: content(
        pk('menu.financial.operation.current.account.statementa')
      ),
      key: AppRouteKey.CURRENTACCOUNTEXTRACT,
      icon: <Financial />,
    },
    {
      label: content(
        pk('menu.financial.operation.estimated.km.excess.calculation')
      ),
      key: AppRouteKey.ESTIMATEDOVERKMCALCULATION,
      icon: <Financial />,
    },
    {
      label: content(
        pk('menu.financial.operation.early.return.penalty.fee.calculation')
      ),
      key: AppRouteKey.EARLYRETURNPENALTYFEECALCULATION,
      icon: <Financial />,
    },
    {
      label: content(pk('menu.service.operation.maintenance')),
      key: AppRouteKey.MAINTENANCE,
      icon: <Service />,
    },
    {
      label: content(pk('menu.service.operation.breakdown')),
      key: AppRouteKey.BREAKDOWN,
      icon: <Service />,
    },
    {
      label: content(pk('menu.service.operation.tire')),
      key: AppRouteKey.TYRE,
      icon: <Service />,
    },
    {
      label: content(pk('menu.service.operation.damage')),
      key: AppRouteKey.ACCIDENTALDAMAGE,
      icon: <Service />,
    },
    {
      label: content(pk('menu.campaign.news.sponsorship')),
      key: AppRouteKey.CAMPAIGNNEWS,
      icon: <News />,
    },
    {
      label: content(pk('menu.help.faq')),
      key: AppRouteKey.FAQ,
      icon: <Help />,
    },
    {
      label: content(pk('menu.help.guide')),
      key: AppRouteKey.GUIDE,
      icon: <Help />,
    },
    {
      label: content(pk('menu.help.feedback')),
      key: AppRouteKey.FEEDBACK,
      icon: <Help />,
    },
  ];
  if (
    visibility(pk('menu.financial.operation.invoice.payment')) &&
    showCreditCard
  ) {
    recommend.push({
      label: content(pk('menu.financial.operation.invoice.payment')),
      key: AppRouteKey.CREDITCARDPAY,
      icon: <Financial />,
    });
  }

  const subCompaniesData: SubCompanyDto[] =
    getSubCompaniesState?.data?.filter(
      (item) => item.businessPartnerId !== userId.businessPartnerId
    ) || [];

  const mergedRecommend = [...recommend, ...subCompaniesData];

  useEffect(() => {
    const sugg = appSearch
      ? mergedRecommend
          .filter((item) => {
            if ('label' in item) {
              return item.label.toLowerCase().includes(appSearch.toLowerCase());
            } else {
              return item.name.toLowerCase().includes(appSearch.toLowerCase());
            }
          })
          .slice(0, 4)
      : [];
    setSuggestions(sugg);
  }, [appSearch]);

  useEffect(() => {
    dispatch(getSubCompanies());
    dispatch(listAllNotification());
  }, [dispatch]);

  const [open, setOpen] = useState(false);

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };
  const itemsLeft = [
    {
      label: 'Profil',
      key: 'SubMenu',
      icon: <UserOutlined />,
      children: [
        {
          key: AppRouteKey.PROFILE,
          label: content(pk('profile.button.profile')),
        },
        {
          key: AppRouteKey.LOGIN,
          label: content(pk('profile.button.log.out')),
          onClick: () => {
            dispatch(logout());
          },
        },
      ],
    },
    {
      label: content(pk('menu.dashboard')),
      key: AppRouteKey.HOME,
      icon: <Dashboard />,
    },
    {
      label: content(pk('menu.user')),
      key: AppRouteKey.USERS,
      icon: <Users />,
    },
    {
      label: content(pk('menu.demand')),
      key: t('demands'),
      icon: <Demands />,
      children: [
        {
          label: content(
            pk('menu.demand.additional.product.service.request')
          ),
          key: AppRouteKey.DEMANDS,
        },
        {
          label: content(pk('menu.demand.process.request')),
          key: AppRouteKey.PROCESSUALDEMANDS,
        },
      ],
    },
    {
      label: content(pk('menu.fleet.vehicle.management')),
      key: 'cars',
      icon: <Cars />,
      children: [
        {
          label: content(
            pk('menu.fleet.vehicle.management.fleet.vehicle.info')
          ),
          key: AppRouteKey.FLEETINFORMATION,
        },
        {
          label: content(
            pk('menu.fleet.vehicle.management.vehicle.hgs.info')
          ),
          key: AppRouteKey.HGSINFO,
        },
        {
          label: content(
            pk('menu.fleet.vehicle.management.vehicle.delivery')
          ),
          key: AppRouteKey.CARDELIVERY,
        },
        {
          label: content(
            pk('menu.fleet.vehicle.management.vehicle.return')
          ),
          key: AppRouteKey.CARRETURN,
        },
        {
          label: content(pk('menu.fleet.vehicle.management.document')),
          key: AppRouteKey.DOCUMENTS,
        },
      ],
    },
    {
      label: content(pk('menu.invoice')),
      key: 'bills',
      icon: <Bills />,
      children: [
        {
          label: content(pk('menu.invoice.operational.bill')),
          key: AppRouteKey.OPERATIONALBILL,
        },
        {
          label: content(pk('menu.invoice.financial.bill')),
          key: AppRouteKey.FINANCIALBILL,
        },
        {
          label: content(pk('menu.invoice.additional.service.billa')),
          key: AppRouteKey.ADDITIONALSERVICES,
        },
        {
          label: content(pk('menu.invoice.other.reflection.bill')),
          key: AppRouteKey.OTHERREFLECTION,
        },
      ],
    },
    {
      label: content(pk('menu.financial.operation')),
      key: 'financial',
      icon: <Financial />,
      children: [
        {
          label: content(
            pk('menu.financial.operation.balance.reconciliation.confirmation')
          ),
          key: AppRouteKey.BALANCECONFIRMATION,
        },
        {
          label: content(
            pk('menu.financial.operation.current.account.statementa')
          ),
          key: AppRouteKey.CURRENTACCOUNTEXTRACT,
        },
        {
          label: content(
            pk('menu.financial.operation.estimated.km.excess.calculation')
          ),
          key: AppRouteKey.ESTIMATEDOVERKMCALCULATION,
        },
        {
          label: content(
            pk('menu.financial.operation.early.return.penalty.fee.calculation')
          ),
          key: AppRouteKey.EARLYRETURNPENALTYFEECALCULATION,
        },
        visibility(pk('menu.financial.operation.invoice.payment')) &&
          showCreditCard && {
            label: content(pk('menu.financial.operation.invoice.payment')),
            key: AppRouteKey.CREDITCARDPAY,
          },
      ].filter(Boolean),
    },
    {
      label: content(pk('menu.service.operation')),
      key: 'service',
      icon: <Service />,
      children: [
        {
          label: content(pk('menu.service.operation.maintenance')),
          key: AppRouteKey.MAINTENANCE,
        },
        {
          label: content(pk('menu.service.operation.breakdown')),
          key: AppRouteKey.BREAKDOWN,
        },
        {
          label: content(pk('menu.service.operation.tire')),
          key: AppRouteKey.TYRE,
        },
        {
          label: content(pk('menu.service.operation.damage')),
          key: AppRouteKey.ACCIDENTALDAMAGE,
        },
      ],
    },
    {
      label: content(pk('menu.campaign.news.sponsorship')),
      key: AppRouteKey.CAMPAIGNNEWS,
      icon: <News />,
      className: 'news',
    },
    {
      label: content(pk('menu.help')),
      key: 'help',
      icon: <Help />,
      children: [
        {
          label: content(pk('menu.help.faq')),
          key: AppRouteKey.FAQ,
        },
        {
          label: content(pk('menu.help.guide')),
          key: AppRouteKey.GUIDE,
        },
        {
          label: content(pk('menu.help.feedback')),
          key: AppRouteKey.FEEDBACK,
        },
      ],
    },
    {
      label: 'Dil',
      key: 'language',
      icon: <FlagOutlined />,
      children: [
        {
          key: i18n.language === 'tr' ? 'en' : 'tr',
          icon: (
            <img
              className="w-4 h-4 mr-1 rounded-full"
              src={i18n.language === 'tr' ? FlagEn : FlagTr}
              alt="..."
            />
          ),
          label: i18n.language === 'tr' ? 'EN' : 'TR',
          onClick: () => changeLanguage(i18n.language === 'tr' ? 'en' : 'tr'),
        },
      ],
    },
    {
      label: 'Canlı Destek',
      key: 'live',
      icon: <CustomerServiceOutlined />,
      onClick: () => {
        getLiveUrl().then((data) => {
          console.log(data.url);
          window.open(data.url, '_blank');
        });
      },
    },
  ];

  const [openKeys, setOpenKeys] = useState<string[]>([]);
  const getCurrentKey = (): string => {
    let currentItem = itemsLeft.find((item) =>
      (item.children as any)?.find((child: any) => current.includes(child?.key))
    );

    if (currentItem) {
      const children = (currentItem.children as any)?.find((child: any) =>
        current.includes(child.key)
      );
      return children?.key || '';
    }

    if (current.includes('language') || current.includes('live')) {
      return '';
    }

    currentItem = itemsLeft.find((item) => current.includes(item.key));

    if (currentItem) {
      return currentItem.key;
    }

    return current;
  };

  const onOpenChange: MenuProps['onOpenChange'] = (keys) => {
    const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);
    if (
      latestOpenKey &&
      items.findIndex((item) => item?.key === latestOpenKey) === -1
    ) {
      setOpenKeys(keys);
    } else {
      setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
    }
  };
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        inputRef.current &&
        !inputRef.current.input?.contains(event.target as Node) &&
        suggestionsRef.current &&
        !suggestionsRef.current.contains(event.target as Node)
      ) {
        setShowSuggestions(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  return (
    <>
      {contextHolder}
      <Modal
        centered
        open={buyCarId !== undefined}
        title={'Arac Satin Alma'}
        onCancel={() => {
          setBuyCarId(undefined);
        }}
        footer={
          <Row gutter={[16, 16]} className={'w-full flex justify-center'}>
            <Col>
              <Button
                loading={buyCarLoading}
                onClick={() => {
                  setBuyCarId(undefined);
                }}
              >
                Hayir
              </Button>
            </Col>
            <Col>
              <Button
                loading={buyCarLoading}
                onClick={() => {
                  if (buyCarId) {
                    setBuyCarLoading(true);
                    AcceptBuyCarNotification(buyCarId).then((data) => {
                      setBuyCarId(undefined);
                      setBuyCarLoading(false);
                      dispatch(listAllNotification());
                    });
                  }
                }}
                type={'primary'}
              >
                Evet
              </Button>
            </Col>
          </Row>
        }
      >
        Filonuzda bulunan araci satin almak ister misiniz ?
      </Modal>

      <Layout.Header id="header" className="flex items-center bg-primary py-3 ">
        <div className="flex flex-grow items-center relative ">
          <img
            src={platformConfig.menuLogo}
            className="cursor-pointer w-40 ml-16 mr-10"
            alt="Logo"
            onClick={() => {
              navigate(provideUrl(AppRouteKey.HOME));
            }}
          />
          <Divider
            type="vertical"
            className="mx-6 h-8 border-white opacity-30 max-xl:hidden"
          />
          <div className="relative w-full">
            <Input
              value={appSearch}
              onChange={(e) => {
                setAppSearch(e.target.value);
                setShowSuggestions(true);
              }}
              className="max-w-[600px] bg-primary rounded-2xl border-2 border-white hover:border-white h-10"
              placeholder={content(pk('profile.main.searchbox'))}
              suffix={<SearchOutlined className="text-2xl text-white" />}
              ref={inputRef}
            />
            {showSuggestions && suggestions.length > 0 && (
              <div className="absolute bg-white border border-gray-200 rounded-xl mt-1 w-full max-w-[600px] z-10">
                {suggestions.map((suggestion: any, index: any) => (
                  <div
                    onClick={() => {
                      if ('label' in suggestion) {
                        <Layout.Sider
                          className="max-xl:hidden"
                          id="left-menu"
                          width={282}
                        >
                          <Menu
                            className="h-full py-6"
                            onClick={onClick}
                            selectedKeys={[getCurrentKey()]}
                            mode="inline"
                            openKeys={openKeys}
                            onOpenChange={onOpenChange}
                          />
                        </Layout.Sider>;
                        console.log(suggestion.key);
                        push(suggestion.key);
                      } else {
                        setSelectedId(suggestion.businessPartnerId);
                        try {
                          dispatch(
                            subCompanySelect(suggestion.businessPartnerId)
                          )
                            .then(() => {
                              message.success('Firma Değişimi Başarılı');
                              window.location.reload();
                              setAppSearch('');
                            })
                            .catch((error) => {
                              console.log(error);
                              message.error('Bir Hata Oluştu');
                              setSelectedId('');
                            });
                        } catch (error) {
                          console.log(error);
                          message.error('Bir Hata Oluştu');
                        }
                      }
                      setShowSuggestions(false);
                    }}
                    key={index}
                    className={`px-4 flex gap-x-5 py-1 w-full hover:bg-gray-100 cursor-pointer`}
                  >
                    {'label' in suggestion ? (
                      <div className="mt-1.5">{suggestion.icon}</div>
                    ) : (
                      <div className="">
                        <UndoOutlined />
                      </div>
                    )}

                    <span className="font-light mt-0.5 truncate">
                      {'label' in suggestion
                        ? suggestion.label
                        : suggestion.name}
                    </span>
                    {'name' in suggestion &&
                    selectedId &&
                    suggestion.businessPartnerId == selectedId ? (
                      <div className="mt-0.5">
                        <Spin />
                      </div>
                    ) : null}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
        <MenuOutlined
          className="block xl:hidden text-white ml-5 text-xl"
          onClick={showDrawer}
        />
        <div>
          <Drawer
            className="w-5/6"
            placement={'left'}
            title={null}
            closeIcon={false}
            onClose={onClose}
            open={open}
          >
            <Menu
              className="h-full  "
              onClick={onClick}
              selectedKeys={[getCurrentKey()]}
              mode="inline"
              items={itemsLeft}
              openKeys={openKeys}
              onOpenChange={onOpenChange}
            />
          </Drawer>
        </div>
        <Dropdown
          placement={'bottomCenter'}
          className="mr-7 max-xl:hidden"
          menu={{ items }}
          dropdownRender={(menu) => (
            <div
              className={
                'w-[282px] py-2 bg-white rounded flex flex-wrap justify-center'
              }
            >
              {overdueNotification && (
                <div className={'w-[218px]'}>
                  <Tooltip title={overdueNotification.body}>
                    <Button
                      className={'p-0 w-[210px] flex items-center'}
                      type="text"
                      onClick={() => {
                        navigate(provideUrl(AppRouteKey.OVERDUE_INVOICE));
                      }}
                    >
                      {notificationIconSelector(overdueNotification.type)}
                      <div
                        className={
                          "ml-2 overflow-hidden overflow-ellipsis whitespace-nowrap'"
                        }
                      >
                        {overdueNotification.body}
                      </div>
                    </Button>
                  </Tooltip>
                </div>
              )}

              {limitedNotifications.map((userNotification) => {
                return (
                  <div className="w-[218px] h-8 flex items-center">
                    <Tooltip title={userNotification.body}>
                      <div
                        onClick={() => {
                          if (
                            userNotification.type ===
                            UserNotificationType.CAR_BUY
                          ) {
                            setBuyCarId(userNotification.id);
                          } else {
                            switch (userNotification.type) {
                              case UserNotificationType.CAR_INSPECTION.toString(): {
                                navigate(
                                  provideUrl(AppRouteKey.FLEETINFORMATION)
                                );
                                break;
                              }
                              case UserNotificationType.KM_EXCEEDED.toString(): {
                                if (isOnDashboard) {
                                  Helpers.scrollToElementById(
                                    'km-exceeded-target'
                                  );
                                } else {
                                  navigate(
                                    provideUrl(AppRouteKey.HOME) +
                                      '#km-exceeded-target'
                                  );
                                }
                                break;
                              }
                              case UserNotificationType.PAYMENT_DUE_DATE.toString(): {
                                if (isOnDashboard) {
                                  Helpers.scrollToElementById(
                                    'payment-due-target'
                                  );
                                } else {
                                  navigate(
                                    provideUrl(AppRouteKey.HOME) +
                                      '#payment-due-target'
                                  );
                                }
                                break;
                              }
                              case UserNotificationType.HEDEFNET_DUE_DATE.toString(): {
                                if (isOnDashboard) {
                                  Helpers.scrollToElementById(
                                    'hedefnet-due-date-target'
                                  );
                                } else {
                                  navigate(
                                    provideUrl(AppRouteKey.HOME) +
                                      '#hedefnet-due-date-target'
                                  );
                                }
                                break;
                              }
                              default:
                                modal.info({
                                  title: 'Bildirim',
                                  content: userNotification.body,
                                  centered: true,
                                  icon: (
                                    <ExclamationCircleFilled
                                      style={{ color: 'red' }}
                                    />
                                  ),
                                  onOk: () => {
                                    ReadListNotification([
                                      userNotification.id,
                                    ]).then((response) => {
                                      if (response.status === 200)
                                        dispatch(listAllNotification());
                                    });
                                  },
                                });
                                break;
                            }
                          }
                        }}
                        className="p-0 w-[210px] flex items-center hover:bg-gray-100 cursor-pointer"
                      >
                        {notificationIconSelector(userNotification.type)}
                        <div className="ml-2 w-[184px] overflow-hidden text-ellipsis whitespace-nowrap">
                          {userNotification.body}
                        </div>
                      </div>
                    </Tooltip>
                    <Button
                      onClick={() => {
                        ReadListNotification([userNotification.id]).then(
                          (response) => {
                            if (response.status === 200)
                              dispatch(listAllNotification());
                          }
                        );
                      }}
                      shape="circle"
                      type={'text'}
                      danger
                      icon={<CloseCircleFilled />}
                    />
                  </div>
                );
              })}
              {limitedNotifications.length > 0 && (
                <Divider style={{ margin: 0 }} />
              )}
              {(notifications === undefined || notifications.length === 0) && (
                <Empty
                  imageStyle={{ height: 50 }}
                  description={content(pk('notification.no.notification'))}
                />
              )}
              {notifications && notifications.length > 0 && (
                <Button
                  onClick={() => {
                    if (notifications) {
                      const normalNotifications = notifications.filter(
                        (notification) => {
                          return notification.id !== null;
                        }
                      );
                      ReadListNotification(
                        normalNotifications?.map((notification) => {
                          return notification.id;
                        })
                      ).then((response) => {
                        if (response.status === 200)
                          dispatch(listAllNotification());
                      });
                    }
                  }}
                  block
                  type="text"
                >
                  {content(pk('notification.mark.as.read.button.text'))}
                </Button>
              )}
            </div>
          )}
        >
          <Badge count={notifications?.length}>
            <Notification />
          </Badge>
        </Dropdown>
        <div className="min-w-[150px] max-xl:hidden">
          <Menu
            mode="horizontal"
            selectedKeys={[current]}
            items={items}
            className="header-menu bg-transparent border-none leading-none"
            onClick={onClick}
          />
        </div>
      </Layout.Header>
    </>
  );
}

export default Header;
